// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"bc1f9b28","890":"c26807c6","905":"90a74ed4"}[chunkId] + ".chunk.css";
};